import React from 'react';
import Button from '@material-ui/core/Button';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import { Link } from "react-router-dom";

class HeaderMenuButton extends React.Component {
  state = {
    anchorEl: null,
  };

  handleClick = event => {
    this.setState({ anchorEl: event.currentTarget });
  };

  handleClose = () => {
    this.setState({ anchorEl: null });
  };

  render() {
    const { title, links } = this.props;
    const { anchorEl } = this.state;

    return (
      <React.Fragment>
        <Button
          aria-owns={anchorEl ? 'control-menu' : null}
          aria-haspopup="true"
          onClick={this.handleClick}
          color="inherit">
          {title}
        </Button>
        <Menu
          id="control-menu"
          anchorEl={anchorEl}
          open={Boolean(anchorEl)}
          onClose={this.handleClose}>
          {links.map((link) => 
          <MenuItem key={link.name} onClick={this.handleClose} component={Link} to={link.path}>{link.name}</MenuItem>)}
          
        </Menu>
      </React.Fragment>
    );
  }
}

export default HeaderMenuButton;


// WEBPACK FOOTER //
// ./src/components/Header/HeaderMenuButton.js